<template>
    <page>
        <module>
            <module-tab title="服务与支持" @mounted="loadCategory">
                <module-column enable-flex>
                    <m-operate>
                        <c-button power="b_problem_edit" color="sys" icon="add" @click="editHandle('category')">新增栏目</c-button>
                    </m-operate>

                    <c-table ref="category" :paging="false" @row-click="loadProblem">
                        <c-table-column
                                label="栏目名称"
                                name="name"
                                width="150"
                        ></c-table-column>

                        <c-table-column
                                label="状态"
                                name="state"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.state==2"><span style="color:darkgreen">启用</span></span>
                                <span v-if="data.state!=2"><span style="color:#999999">禁用</span></span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                type="sort"
                                label="排序"
                                width="120"
                                @sort="categorySort"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                label="操作"
                                width="170"
                        >
                            <template v-slot="row">
                                <c-table-button power="b_problem_edit" v-if="row.data.state == 1"  @click="updateCategoryState(2,row.data)">启用</c-table-button>
                                <c-table-button power="b_problem_edit" v-if="row.data.state == 2"  @click="updateCategoryState(1,row.data)">禁用</c-table-button>
                                <c-table-button power="b_problem_edit" @click="editHandle('category', row)">编辑</c-table-button>
                                <c-table-button power="b_problem_edit" @click="deleteHandle('category', row)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>

                <module-column enable-flex>
                    <m-operate>
                        <c-button power="b_problem_edit" color="sys" icon="add" @click="editHandle('problem')">新建信息</c-button>
                    </m-operate>

                    <c-table ref="problem" :paging="false">
                        <c-table-column
                                label="信息标题"
                                name="name"
                                width="150"
                        ></c-table-column>

                        <!--                        <c-table-column
                                                        label="问答内容"
                                                        name="content"
                                                ></c-table-column>-->

                        <c-table-column
                                label="状态"
                                name="state"
                                width="80"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.state==2"><span style="color:darkgreen">启用</span></span>
                                <span v-if="data.state!=2"><span style="color:#999999">禁用</span></span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                type="sort"
                                label="排序"
                                @sort="problemSort"
                                width="120"
                        ></c-table-column>

                        <c-table-column
                                type="button"
                                label="操作"
                                width="170"
                        >
                            <template v-slot="row">
                                <c-table-button power="b_problem_edit" v-if="row.data.state == 1"  @click="updateState(2,row.data)">启用</c-table-button>
                                <c-table-button power="b_problem_edit" v-if="row.data.state == 2"  @click="updateState(1,row.data)">禁用</c-table-button>
                                <c-table-button power="b_problem_edit" @click="editHandle('problem', row)">编辑</c-table-button>
                                <c-table-button power="b_problem_edit" @click="deleteHandle('problem', row)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-column>
            </module-tab>
        </module>

        <c-dialog ref="categoryEdit" :title="editState ? '编辑栏目' : '新增栏目'" width="600" @resolve="editCategoryHandle">
            <c-form ref="categoryForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="栏目名称" name="name" required></c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="problemEdit" :title="editState ? '编辑信息' : '新建信息'" width="900" @resolve="editProblemHandle">
            <c-form ref="problemForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="信息标题" name="name" required></c-form-item>
                <c-form-item type="select" label="所属栏目" name="category_id" :options="categoryList" required></c-form-item>
                <c-form-item type="editor" label="信息内容" name="content"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_problem',

        data() {
            return {
                editState: false,
                fixedPage: false,
                categoryList: []
            }
        },

        methods: {
            loadCategory() {
                this.$refs.category.load({
                    url: '/problem/category/list'
                });
            },

            loadProblem(row) {
                this._category = row;
                this.$refs.problem.load({
                    url: '/problem/list',
                    data: {
                        category_id: row.data.id
                    }
                });
            },

            editHandle(type, row) {
                this.editState = !!row;
                if (row) {
                    this.$refs[`${type}Form`].set(row.data);
                } else {
                    this.$refs[`${type}Form`].clear();
                }
                if (type == 'problem') {
                    this.categoryList = Array.from(this.$refs.category.getRow(), item => {
                        return {
                            name: item.data.name,
                            value: item.data.id
                        }
                    });

                    if (this._category && !this.editState) {
                        this.$nextTick(() => {
                            this.$refs.problemForm.set({
                                category_id: this._category.data.id
                            });
                        });
                    }
                }

                this.$refs[`${type}Edit`].open();
            },

            editCategoryHandle(stop) {
                stop();
                this.$refs.categoryForm.submit({
                    url: '/problem/category/edit',
                    rule: {
                        name: '请填写栏目标题'
                    },
                    success: () => {
                        this.$refs.category.update();
                        this.$refs.categoryEdit.close();
                    }
                });
            },

            editProblemHandle(stop) {
                stop();
                this.$refs.problemForm.submit({
                    url: '/problem/edit',
                    rule: {
                        name: '请填写信息标题',
                        category_id: [{
                            type: 'empty',
                            word: '请选择所属栏目',
                            skip: () => {
                                return this.fixedPage
                            }
                        }]
                    },
                    success: () => {
                        if (this.fixedPage) {
                            this.$refs.page.update();
                        } else {
                            this.$refs.problem.update();
                        }
                        this.$refs.problemEdit.close();
                    }
                });
            },

            categorySort(row, type, next) {
                this.sortHandle('/problem/category/sort', row, type, next);
            },

            problemSort(row, type, next) {
                this.sortHandle('/problem/sort', row, type, next);
            },

            sortHandle(url, row, type, next) {
                console.log(row.prev(),'<---')
                this.request({
                    url: url,
                    data: {
                        id1: row.data.id,
                        id2: type == 'up' ? row.prev().data.id : row.next().data.id,
                    },
                    loading: true,
                    success: data => {
                        if (type == 'top' || type == 'bottom') {
                            this.$refs.category.update();
                        } else {
                            next();
                        }
                    }
                });
            },

            deleteHandle(type, row) {
                this.$confirm({
                    text: `确定要删除此${type == 'problem' ? '信息' : '栏目'}吗？`,
                    resolve: () => {
                        this.request({
                            url: type == 'problem' ? '/problem/remove' : '/problem/category/remove',
                            data: {
                                id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '删除成功'
                                });
                                row.remove();
                            }
                        });
                    }
                });
            },
            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/problem/state',
                            data: {id:val.id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.problem.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            updateCategoryState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/problem/category/state',
                            data: {id:val.id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.category.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
        }
    }
</script>
